import { useCallback, useEffect, useRef, useState } from "react";
// How often we recalculate the time left
const INTERVAL = 10;
/**
 * `useToast` timer handles ensuring the toast is removed after a set amount of
 * time.
 */
export const useToastTimer = (timeout) => {
    const [show, setShow] = useState(true);
    const timeLeft = useRef(timeout);
    const intervalRef = useRef(null);
    // Pauses/stops the timer
    const handleClearInterval = useCallback(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
    }, []);
    // Used to end the timer early
    const close = useCallback(() => {
        handleClearInterval();
        setShow(false);
    }, [handleClearInterval]);
    // Starts/restarts the timer when a timeout is provided.
    const handleStartTimer = useCallback(() => {
        if (timeLeft.current !== undefined) {
            const currentInterval = setInterval(() => {
                if (timeLeft.current && timeLeft.current > 0) {
                    timeLeft.current -= INTERVAL;
                }
                else {
                    setShow(false);
                    handleClearInterval();
                }
                intervalRef.current = currentInterval;
            }, INTERVAL);
        }
    }, [handleClearInterval]);
    useEffect(() => {
        handleStartTimer();
        return () => {
            handleClearInterval();
        };
    }, [handleStartTimer, handleClearInterval]);
    return {
        show,
        close,
        startTimer: handleStartTimer,
        pauseTimer: handleClearInterval,
    };
};
